// PDF Fonts. These name entries in pdfmake's virtual file system rather than
// remote URLs: pdfmake used to fetch the Roboto files straight from
// cdnjs.cloudflare.com at generation time, so any user whose browser couldn't
// reach that CDN (content blocker, firewall, CDN outage) got no PDF at all. The
// base64 copies in ./pdfMakeFonts are bundled with the app instead.
export const pdfFonts = {
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}
